<script>
    export default {
        props: {
            value: [String, Number],
            label: String,
            labelWidth: String,
            field: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            list: {
                type: Array,
                default() {
                    return [];
                }
            },
        },
        data() {
            return {}
        },
        methods: {
            input_value(v) {
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
                if(v!==this.value){
                    this.$emit('change', v);
                    if (this.field) {
                        this.$emit('change-field', {
                            field: this.field,
                            value: v,
                        });
                    }
                }
            },
        },
        computed: {},
        watch: {},
        components: {},
        mounted() {

        },
        destroyed() {

        },
    }
</script>
<template>
    <form-group class="form-radio" :label-width="labelWidth" :label="label">
        <el-radio-group :value="value" :disabled="disabled" @input="input_value">
            <el-radio-button
                    v-for="item in list"
                    :label="item.value"
                    :key="item.value">{{item.label}}</el-radio-button>
        </el-radio-group>
    </form-group>
</template>
